import { useEffect, useRef, useState } from "react";
import { Accordion, Button } from "devextreme-react";
import styled from "styled-components";
import { useSelector } from "react-redux";
import { divisionOrder } from "../data";
import { faMinus } from "@fortawesome/free-solid-svg-icons";
import StudyStatusItem from "./StudyStatusItem";
import TimelinePopup from "./TimelinePopup";
import EnrollStatusPopup from "./EnrollStatusPopup";
import { getReportDivision } from "../access";

const StudyStatusViewerWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  h3 {
    margin: 0;
    margin-right: 16px;
    display: inline;
    font-size: 1em;
  }
  > div:first-child {
    display: flex;
    justify-content: space-between;
    margin-bottom: 8px;
    .dx-button {
      margin: 0;
      border-radius: 5px !important;
    }
  }
`;

const StudyStatusBox = styled.div`
  width: 100%;
  height: 100%;
  h4 {
    margin: 0;
    margin-bottom: 4px;
  }
  h4 + div {
    padding: 8px;
    border: 1px solid #b0b0b0;
    border-radius: 5px;
    margin-bottom: 8px;
  }
`;

const NotificationBox = styled.div`
  width: 100%;
  height: 100%;
  h4 {
    margin: 0;
    margin-bottom: 4px;
  }
  h4 + div {
    padding: 8px;
    border: 1px solid #b0b0b0;
    border-radius: 5px;
    margin-bottom: 8px;
  }
  p {
    margin: 4px 0;
  }
  table {
    width: 100%;
    table-layout: fixed;
    word-break: break-all;
    height: auto;
    td {
      background-color: #fafafa;
      padding: 8px 16px;
      p {
        margin: 0;
      }
    }
    tr:nth-child(2n) {
      td {
        background-color: white;
      }
    }
  }
  img {
    /* display: block; */
    max-width: 100%;
    height: auto;
  }
`;

const PopupWrapper = styled.div`
  display: flex;
  margin: 8px 0;
  .dx-button {
    float: left;
    margin: 0;
    margin-right: 16px;
    font-size: 13px;
  }
`;

const StudyStatusViewer = ({
  contrNo,
  isEditable,
  isEnrollmentStatusUsed,
  setMode,
  studyStatusDataSource,
  yearMonth,
}) => {
  const accordionDataSource = divisionOrder
    .filter((div) => studyStatusDataSource[div])
    .map((div) => ({ title: div, data: studyStatusDataSource[div] }));

  const [isExpandedAll, setExpandedAll] = useState(false);

  const accordionMenuRef = useRef(null);

  //! userInfo.div
  const userInfo = useSelector((state) => state.userInfo);
  const div = getReportDivision(userInfo.div);
  // const div = "SA";

  useEffect(() => {
    // * accordionDataSource를 dataSource에 입력.
    accordionMenuRef.current.instance.option("dataSource", accordionDataSource);
    //! user의 div에 해당하는 메뉴만 펼침.
    accordionMenuRef.current.instance.option(
      "selectedItems",
      accordionDataSource.filter((el) => el.title === div)
    );
  }, [studyStatusDataSource]);

  const handleClickMode = () => {
    setMode("statusEdit");
  };

  const handleExpandAllButton = () => {
    if (isExpandedAll) {
      setExpandedAll(false);
      accordionMenuRef.current.instance.option("selectedItems", []);
    } else {
      setExpandedAll(true);
      const expandAll = accordionMenuRef.current.instance.getDataSource()._items;
      accordionMenuRef.current.instance.option("selectedItems", expandAll);
    }
  };

  const renderAccordionItem = (e) => {
    const div = e.title;
    const data = e.data;
    if (div === "OF") {
      return (
        <NotificationBox>
          <h4>Notification</h4>
          <div dangerouslySetInnerHTML={{ __html: data?.[3]?.[0].descr }} />
        </NotificationBox>
      );
    }
    return (
      <div>
        <StudyStatusBox>
          <h4>Project Status</h4>
          <div>
            {data[1]?.map((item, idx) => (
              <StudyStatusItem key={`status${idx + 1}`} item={item} />
            ))}
          </div>
        </StudyStatusBox>
        <StudyStatusBox>
          <h4>Action Plan</h4>
          <div>
            {data[2]?.map((item, idx) => (
              <StudyStatusItem key={`plan${idx + 1}`} item={item} icon={faMinus} color="black" />
            ))}
          </div>
        </StudyStatusBox>
      </div>
    );
  };

  return (
    <StudyStatusViewerWrapper>
      <div>
        <div>
          <h3>Study Status</h3>
          <Button
            icon={
              !isExpandedAll
                ? "fa-solid fa-up-right-and-down-left-from-center"
                : "fa-solid fa-down-left-and-up-right-to-center"
            }
            id="expandAllButton"
            onClick={handleExpandAllButton}
            stylingMode={!isExpandedAll ? "contained" : "outlined"}
            type="success"
          />
        </div>
        <Button
          disabled={!isEditable}
          icon="edit"
          id="editButton"
          onClick={handleClickMode}
          stylingMode="contained"
          type="normal"
        />
      </div>
      <PopupWrapper>
        <TimelinePopup contrNo={contrNo} isEditable={isEditable} yearMonth={yearMonth} />
        <EnrollStatusPopup
          contrNo={contrNo}
          isEditable={isEditable}
          isEnrollmentStatusUsed={isEnrollmentStatusUsed}
          yearMonth={yearMonth}
        />
      </PopupWrapper>
      <Accordion collapsible={true} itemRender={renderAccordionItem} multiple={true} ref={accordionMenuRef} />
    </StudyStatusViewerWrapper>
  );
};

export default StudyStatusViewer;
